import React from 'react';
import DownArrow from 'src/assets/images/DownArrow.svg';
import UpArrow from 'src/assets/images/UpArrow.svg';
import { useSelector, useDispatch } from 'react-redux';
import { setCalendarView } from 'src/pages/home/redux/actions';
import CalendarNotch from 'src/assets/images/CalendarNotch.svg';
import usePreloadImagesEffect from '../hooks/usePreloadImagesEffect';
import useCalendarFooterTouchHandlers from '../hooks/useCalendarFooterTouchHandlers';
const CalendarFooter = () => {
    const dispatch = useDispatch();
    const calendarView = useSelector(
        (state) => state.filterReducer.calendarView
    );
    const setCalendarViewLocal = (view) => {
        dispatch(setCalendarView(view));
        localStorage.setItem('lastSelDLPCalView', view);
    };
    usePreloadImagesEffect([DownArrow, UpArrow]);
    const {
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
    } = useCalendarFooterTouchHandlers(setCalendarViewLocal);
 
    return (
        <div className="calendar-footer">
            <img
                className="calendar-curve"
                src={CalendarNotch}
                data-srcset={CalendarNotch}
                alt="calendarNotch"
                width="auto"
                height="auto"
            />
            {calendarView === 'Week' ? (
                <div
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    className="week-month-arrow"
                    onClick={() => setCalendarViewLocal('Month')}
                >
                    <img
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        src={DownArrow}
                        alt="down arrow"
                        onClick={() => setCalendarViewLocal('Month')}
                        width="auto"
                        height="auto"
                    />
                </div>
            ) : (
                <div
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    className="month-week-arrow"
                    onClick={() => setCalendarViewLocal('Week')}
                >
                    <img
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        src={UpArrow}
                        alt="up arrow"
                        onClick={() => setCalendarViewLocal('Week')}
                        width="auto"
                        height="auto"
                    />
                </div>
            )}
        </div>
    );
};

export default CalendarFooter;
